import { Box, MenuItem, Select } from '@mui/material';
import { useAnalyzeAudience } from 'client/modules/Analyze/AnalyzeAudienceContext';
import ActivityIndicator from 'client/modules/App/components/ActivityIndicator/ActivityIndicator';
import SearchDateRangeControl from 'client/modules/Surveys/components/SearchDateRange/SearchDateRangeControl';
import React, { useCallback } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

const messages = defineMessages({
  all: {
    id: 'SearchDateRange.AllTime',
    defaultMessage: 'All time',
  },
});

const styles = {
  root: {
    display: 'flex',
    gap: 2,
    marginBottom: 2,
  },
  select: {
    backgroundColor: 'white',
    '& .MuiSelect-select': { py: 1.5, minWidth: 160 },
  },
};

function AnalyzeAudienceControls() {
  const { dateRange, setDateRange, savedSearchId, setSavedSearchId, searches, isLoadingSearches } =
    useAnalyzeAudience();
  const { formatMessage } = useIntl();

  const handleChangeSavedSearch = useCallback(
    event => {
      setSavedSearchId(event.target.value);
    },
    [setSavedSearchId],
  );

  return (
    <Box sx={styles.root}>
      {/* TODO(Phase 3.1): SaveAudienceSearchDialog — save ad-hoc audience filters as saved search */}
      <SearchDateRangeControl
        field="created_at"
        title={<FormattedMessage id="analyze.dateRange" defaultMessage="Date range" />}
        onChange={setDateRange}
        value={dateRange}
        emptyValue={formatMessage(messages.all)}
        alwaysOpen
      />
      <Select
        value={savedSearchId}
        onChange={handleChangeSavedSearch}
        sx={styles.select}
        displayEmpty
      >
        <MenuItem value="all">
          <FormattedMessage id="analyze.allResponses" defaultMessage="All responses" />
        </MenuItem>
        {isLoadingSearches ? (
          <MenuItem disabled>
            <ActivityIndicator.Label />
          </MenuItem>
        ) : (
          searches?.map(s => (
            <MenuItem key={s._id} value={s._id}>
              {s.name}
            </MenuItem>
          ))
        )}
      </Select>
    </Box>
  );
}

export default AnalyzeAudienceControls;
